import { useEffect } from 'react';

import { Router } from '~pages';

// import { CssBaseline } from '~shared/ui';
import { useNotification, useWindowInnerWidth } from '~shared/ui';

import { withProviders } from './providers';
import { AppProps } from './types';

// import { PageContextBuiltIn } from 'vite-plugin-ssr';
// import { HelmetProvider } from 'react-helmet-async';

// import { PageContext, PageContextProvider } from '~shared/model';

// import { clientProvider } from '../lib/emotion';

import './styles/antd.scss';
import './styles/tailwind.css';
import './styles/index.scss';
import './styles/fontFamily.scss';

const App: React.FC<AppProps> = () => {
  // const [innerHigth, setInnerHigth] = useState<number | string>('100%');
  const windowWidth = useWindowInnerWidth();
  const notification = useNotification();

  useEffect(() => {
    if (windowWidth <= 768) {
      // setInnerHigth(window.innerHeight);
    }
  }, [windowWidth]);

  return (
    <>
      <Router />
      {notification.contextHolder}
    </>
  );
};

const ProvidedApp: React.FC<AppProps> = withProviders(App);

export { ProvidedApp as App };
